<template>
    <!-- IE 2026 09 24 / ODOO-341407 (заказ Игоря: «юзер-френдли просмотр / правка названий на трёх языках для виджета, колонки, параметра»):
         карточка «Translations» — одна на приложение (App.vue, store.i18nCard), открывается у элемента: глобус в шапке виджета / пункт
         «Translations…» меню виджета (i18n_titles_open), кнопка «Translations» формы ячейки и пункт ≡ таблицы (AttrGrid i18n_cell_open /
         i18n_menu_open). Таблица 3 языка × поля (Title — строка, Tooltip / многострочные поля — textarea с автоподгоном до ~12 строк).
         Строка English правит базу (одна для всех языков); у uk/ru пустая ячейка показывает словарный вариант серым курсивом («◌ auto»,
         i18n_values_get), ввод делает перевод ручным («✎»), ✕ — снова словарь. Apply: запись сохранена и не «жёлтая» → команда бэка
         i18n_values_set (пустое значение = удалить ключ; вместе с items уходит expected — значения базы и переводов, которые карточка показала при
         открытии: конфликт бэк объявляет только по реальному изменению целевых полей, а не по sequence_id — IE 2026 09 24 / ODOO-341407; при
         conflict карточка показывает текущее значение и кнопку «Reload values»: перечитать ячейки из ответа, правки оставить, Apply повторить);
         запись новая / с несохранёнными правками → только память
         + _meta.modified (уедет обычным Save). Esc — закрыть, Ctrl+Enter — Apply. Дизайн: docs/audit-2026-09-04/i18n_title_editor_design_2026-09-23.md (B1)
         IE 2026 09 25 / ODOO-341407 (этап 2 переводов данных 1С): запись загружаемого справочника (бэк i18n_values_get record → loaded) — у названия видно,
         откуда значение (✎ manual — ручной перевод, хранится в I18N-OVERRIDE и переживает перезагрузки справочника; ◌ 1C / CLDR — из загрузки),
         пустая ячейка показывает, что даст загрузка; у справочника с не английской базой строка English правит английский вариант meta.title_en,
         а базовое название (как загружено) показано над таблицей и не правится; ✕ у ручного — снова значение из загрузки. -->
    <teleport :to="fsRoot || 'body'">
        <div v-if="visible" class="i18n-card" ref="card" :style="posStyle" :class="{ 'i18n-card-mobile': isMobile }"
            role="dialog" :aria-label="t('Translations')" @keydown="onKeydown" @mousedown.stop>
            <div class="i18n-card-head">
                <i class="pi pi-globe i18n-card-globe"></i>
                <span class="i18n-card-title">{{ t('Translations') }}<template v-if="label"> · {{ label }}</template></span>
                <span class="i18n-card-mode" :title="memoryOnly ? t('The record has unsaved changes (or is new): Apply writes to the form only — save the record to store the translations') : t('Apply stores the translations at once (the rest of the record is not touched)')">
                    <i class="pi" :class="memoryOnly ? 'pi-pencil' : 'pi-save'"></i>{{ memoryOnly ? t('to the form') : t('to the record') }}</span>
                <i class="pi pi-times i18n-card-close" :title="t('Close')" @click.stop="hide()"></i>
            </div>
            <div class="i18n-card-body">
                <div v-if="recBaseNote" class="i18n-card-base" :title="t('The title as loaded (BAS). It is not edited here: the next load would overwrite it')">{{ recBaseNote }}</div>   <!-- IE 2026 09 25 / ODOO-341407 --><!-- IE 2026 09 28 / ODOO-342342: 1С → BAS (слово Игоря) -->
                <table class="i18n-table">
                    <thead>
                        <tr>
                            <th class="i18n-th-lang"></th>
                            <th v-for="f in fields" :key="'h' + f.key" class="i18n-th-field">{{ f.label }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="L in langs" :key="L.id" :class="{ 'i18n-row-base': L.id === 'en', 'i18n-row-current': L.id === curLang }">
                            <td class="i18n-td-lang">
                                <div class="i18n-lang-name">{{ L.title }}</div>
                                <div v-if="L.id === 'en'" class="i18n-lang-note">{{ enVariantAny ? t('English title') : t('Base for all languages') }}</div>   <!-- IE 2026 09 25 / ODOO-341407: у справочника с не английской базой — английский вариант -->
                                <div v-else-if="L.id === curLang" class="i18n-lang-note">{{ t('Your language') }}</div>
                            </td>
                            <td v-for="f in fields" :key="L.id + f.key" class="i18n-td-cell" :class="{ 'i18n-td-multi': f.multiline }">
                                <div class="i18n-cell">
                                    <textarea v-if="f.multiline" :ref="'in-' + L.id + '-' + f.key" class="i18n-in i18n-in-multi" rows="1"
                                        v-model="f.draft[L.id]" :placeholder="placeholderOf(f, L.id)" spellcheck="false"
                                        :readonly="readOnly" @input="autosize($event.target)" @focus="autosize($event.target)"></textarea>
                                    <input v-else :ref="'in-' + L.id + '-' + f.key" class="i18n-in" type="text" v-model="f.draft[L.id]"
                                        :placeholder="placeholderOf(f, L.id)" spellcheck="false" autocomplete="off" :readonly="readOnly" />
                                    <!-- IE 2026 09 25 / ODOO-341407 (этап 2): название записи загружаемого справочника — источник значения (manual / 1C / CLDR / база) -->
                                    <span class="i18n-badge" v-if="f.loaded && (L.id !== 'en' || f.enVariant)">
                                        <template v-if="!f.draft[L.id]">
                                            <span v-if="f.auto[L.id]" class="i18n-auto" :title="t('From the loaded data — shown while there is no manual translation')">◌ {{ srcLabel(f.auto[L.id].src) }}</span>
                                            <span v-else class="i18n-none" :title="t('No translation: the base title is shown')">—</span>
                                        </template>
                                        <template v-else-if="f.draft[L.id] === f.stored[L.id] && f.src[L.id] && f.src[L.id] !== 'manual'">
                                            <span class="i18n-auto" :title="t('From the loaded data — type to replace it with a manual translation')">◌ {{ srcLabel(f.src[L.id]) }}</span>
                                        </template>
                                        <template v-else>
                                            <span class="i18n-manual" :title="t('Manual translation — kept over the reloads of the catalog')">✎ {{ t('manual') }}</span>
                                            <i v-if="!readOnly" class="pi pi-times i18n-clear" :title="t('Clear — back to the loaded value')" @click.stop="clearCell(f, L.id)"></i>
                                        </template>
                                    </span>
                                    <span class="i18n-badge" v-else-if="L.id !== 'en'">
                                        <template v-if="!f.draft[L.id]">
                                            <span v-if="f.dict[L.id]" class="i18n-auto" :title="t('From the dictionary — not stored on the record')">◌ {{ t('auto') }}</span>
                                            <span v-else class="i18n-none" :title="t('No translation: the English text is shown')">—</span>
                                        </template>
                                        <template v-else>
                                            <span class="i18n-manual" :title="f.dict[L.id] && f.draft[L.id] === f.dict[L.id] ? t('Stored on the record and equal to the dictionary') : t('Stored on the record')">✎<template v-if="f.dict[L.id] && f.draft[L.id] === f.dict[L.id]"> = {{ t('dictionary') }}</template></span>
                                            <i v-if="!readOnly" class="pi pi-times i18n-clear" :title="f.dict[L.id] ? t('Clear — back to the dictionary') : t('Clear the translation')" @click.stop="clearCell(f, L.id)"></i>
                                        </template>
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="i18n-card-legend">
                <template v-if="recInfo">   <!-- IE 2026 09 25 / ODOO-341407: запись загружаемого справочника -->
                    <span>✎ {{ t('manual') }} = {{ t('kept over the reloads (translation overrides)') }}</span> · <span>◌ BAS / CLDR = {{ t('from the loaded data') }}</span> ·<!-- IE 2026 09 28 / ODOO-342342: 1С → BAS -->
                </template>
                <span>◌ {{ t('auto') }} = {{ t('from the dictionary, not stored') }}</span> · <span>✎ = {{ t('stored on the record') }}</span>
                <span v-if="dictState === 'loading'"> · {{ t('loading the dictionary…') }}</span>
                <span v-else-if="dictState === 'off'" :title="t('The dictionary command is not available on this server — drafts are not shown')"> · {{ t('dictionary unavailable') }}</span>
            </div>
            <div class="i18n-card-foot">
                <button v-if="!readOnly" class="i18n-btn" type="button" :disabled="!canUseDict" :title="t('Copy the dictionary variants into the empty cells (they become stored translations)')" @click.stop="useDictionary">
                    {{ t('Use dictionary') }} → {{ otherLangs.map(l => l.id).join(' ') }}</button>
                <button v-if="!readOnly" class="i18n-btn" type="button" :disabled="!canResetDict" :title="recInfo ? t('Remove the manual translations — the loaded values apply again') : t('Remove the stored translations — the dictionary applies again')" @click.stop="resetToDictionary">
                    {{ recInfo ? t('Reset to loaded values') : t('Reset to dictionary') }}</button>   <!-- IE 2026 09 25 / ODOO-341407: запись загружаемого справочника -->
                <span class="i18n-foot-spacer"></span>
                <span v-if="error" class="i18n-error" :title="error">{{ error }}</span>
                <button v-if="conflict && !readOnly" class="i18n-btn i18n-btn-reload" type="button" :title="t('Re-read the current values of these fields (your edits are kept), then apply again')" @click.stop="reloadValues">
                    <i class="pi pi-refresh"></i> {{ t('Reload values') }}</button>   <!-- IE 2026 09 24 / ODOO-341407: конфликт по целевым полям -->
                <button class="i18n-btn" type="button" @click.stop="hide()">{{ readOnly ? t('Close') : t('Cancel') }}</button>
                <button v-if="!readOnly" class="i18n-btn i18n-btn-apply" type="button" :disabled="!dirty || busy" :title="t('Apply (Ctrl+Enter)')" @click.stop="apply">
                    <i v-if="busy" class="pi pi-spin pi-spinner"></i>{{ t('Apply') }}</button>
            </div>
        </div>
    </teleport>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import { t, LANGUAGES, LANGUAGE_IDS, enabledLanguages } from '@/i18n'   // IE 2026 09 26 / ODOO-341407: enabledLanguages — строки языков, включённых в базе
import { fullscreenEl } from '@/utils/overlayRoot'

export default {
    name: 'I18nTitles',
    setup() {
        const store = useMainStore()
        return { store }
    },
    data: () => ({
        visible: false,
        label: '',
        record: null,
        fields: [],          // [{ key, label, multiline, basePath, langPaths: {uk, ru}, base, stored: {uk, ru}, dict: {uk, ru}, draft: {en, uk, ru} }]
        memoryOnly: false,
        readOnly: false,
        anchorEl: null,
        afterApply: null,
        pos: { left: 16, top: 16, width: 720 },
        dictState: '',       // '' | 'loading' | 'ok' | 'off'
        busy: false,
        error: '',
        conflict: null,      // IE 2026 09 24 / ODOO-341407: ответ-конфликт бэка { path, current, values } — кнопка «Reload values»
        dictCache: {},
        recInfo: null,       // IE 2026 09 25 / ODOO-341407: сведения бэка о записи загружаемого справочника (i18n_values_get record: base_lang, src, auto, override)
    }),
    computed: {
        // IE 2026 09 26 / ODOO-341407: строки — только языки, включённые в этой базе (сегмент I18N-LANGUAGES); переводы выключенных языков в записи
        // не показываются и не меняются (Apply шлёт только показанные ячейки)
        langs() { void this.store._settingsEpoch; return enabledLanguages() },
        otherLangs() { return this.langs.filter(l => l.id !== 'en') },
        curLang() { return this.store.get_lang() || 'en' },
        isMobile() { return !!this.store.mobileUi?.on },
        fsRoot() { return fullscreenEl() },
        posStyle() {
            if (this.isMobile) return { left: '8px', right: '8px', top: 'calc(8px + env(safe-area-inset-top, 0px))', maxHeight: 'calc(100vh - 16px)' }
            return { left: this.pos.left + 'px', top: this.pos.top + 'px', width: this.pos.width + 'px' }
        },
        dirty() { return this.changes().length > 0 },
        canUseDict() { return this.fields.some(f => this.otherLangs.some(l => !f.draft[l.id] && f.dict[l.id])) },
        canResetDict() { return this.fields.some(f => this.editLangs(f).some(l => !!f.draft[l.id])) },
        // IE 2026 09 25 / ODOO-341407: хоть у одного поля строка English правит английский вариант (справочник с не английской базой)
        enVariantAny() { return this.fields.some(f => f.enVariant) },
        // IE 2026 09 25 / ODOO-341407: базовое название записи загружаемого справочника (как загружено) — над таблицей, не правится
        recBaseNote() {
            const info = this.recInfo
            if (!info || !this.enVariantAny) return ''
            const lang = (LANGUAGES.find(l => l.id === info.base_lang) || {}).title || info.base_lang
            return t('Base title ({lang}, as loaded): {title}', { lang, title: info.title || '' })
        },
    },
    methods: {
        t,
        // opts: { label, record, fields: [{ key, label, multiline, basePath, langPaths: {uk, ru} }], anchorEl, memoryOnly, readOnly, afterApply }
        open(opts) {
            const store = this.store
            if (!opts?.record || !Array.isArray(opts.fields) || !opts.fields.length) return false
            this.hide()
            this.record = opts.record
            this.label = opts.label || ''
            this.anchorEl = opts.anchorEl || null
            this.afterApply = typeof opts.afterApply === 'function' ? opts.afterApply : null
            this.readOnly = !!opts.readOnly
            const _meta = opts.record._meta || {}
            this.memoryOnly = !!(opts.memoryOnly || !opts.record.id || _meta.new || _meta.modified)
            this.error = ''
            this.conflict = null   // IE 2026 09 24 / ODOO-341407
            this.recInfo = null    // IE 2026 09 25 / ODOO-341407
            this.fields = opts.fields.map(f => {
                const base = this._str(this._baseOf(opts.record, f.basePath))   // IE 2026 09 24 / ODOO-341407: английская база, не перевод бэка на копии
                const stored = {}, draft = { en: base }
                for (const L of this.otherLangs) {
                    stored[L.id] = this._str(store.get_value(opts.record, f.langPaths?.[L.id]))
                    draft[L.id] = stored[L.id]
                }
                // IE 2026 09 24 / ODOO-341407 (уточнение Игоря): черновики строк от вызывающего (глобус режима правки заголовка — текст инпута шапки)
                const preset = opts.drafts && typeof opts.drafts === 'object' ? opts.drafts[f.key] : null
                if (preset && typeof preset === 'object') for (const [lg, v] of Object.entries(preset)) if (lg in draft && typeof v === 'string') draft[lg] = v
                return { key: f.key, label: f.label || f.key, multiline: !!f.multiline, basePath: f.basePath, langPaths: { ...(f.langPaths || {}) },
                    base, stored, dict: {}, draft, loaded: false, enVariant: false, src: {}, auto: {} }   // IE 2026 09 25 / ODOO-341407: loaded / enVariant / src / auto — запись загружаемого справочника
            })
            this.visible = true
            this.dictLoad()
            this.recordInfoLoad()   // IE 2026 09 25 / ODOO-341407
            this.$nextTick(() => {
                this.place()
                this.autosizeAll()
                this.focusFirst()
                this._installOutside()
            })
            return true
        },
        hide() {
            if (!this.visible) return
            this.visible = false
            this._removeOutside()
            this.conflict = null   // IE 2026 09 24 / ODOO-341407
            this.recInfo = null    // IE 2026 09 25 / ODOO-341407
            this.record = null
            this.afterApply = null
            this.anchorEl = null
        },
        _str(v) { return (v === undefined || v === null) ? '' : (typeof v === 'string' ? v : String(v)) },
        // IE 2026 09 24 / ODOO-341407 (проверка dev02, форма строки колонки под uk: Apply получал ложный «changed by another user» — карточка
        // брала базой словарный перевод «Основний постачальник», а в базе 'Main Supplier'): строки, которые бэк перевёл на копии ответа
        // (localize_record_rows: doc.viewList / fields / pages …, пометка _i18n + бэкап {key}_en; так же relocalize на клиенте), — база
        // карточки и expected = английский бэкап, а не показанный перевод
        _baseOf(record, path) {
            const store = this.store
            const i = String(path || '').lastIndexOf('.')
            const parent = i < 0 ? record : store.get_value(record, path.slice(0, i))
            const key = i < 0 ? path : path.slice(i + 1)
            if (parent && typeof parent === 'object' && parent._i18n && typeof parent[key + '_en'] === 'string') return parent[key + '_en']
            return store.get_value(record, path)
        },
        // ---- словарь: варианты a.t() для английских баз (серым курсивом = placeholder; «Use dictionary» материализует) ----
        dictLoad() {
            const texts = Array.from(new Set(this.fields.map(f => f.base).filter(s => s && s.trim())))
            const need = texts.filter(s => !this.dictCache[s])
            // IE 2026 09 24 / ODOO-341407 (проверка dev02: у подсказки без словарной статьи карточка показывала «◌ auto» с английским текстом,
            // «Use dictionary» записал бы английский текст переводом): a.t() без статьи возвращает сам текст — это «нет перевода» (—), не вариант
            const applyCache = () => { for (const f of this.fields) { const d = this.dictCache[f.base] || {}; f.dict = {}; for (const L of this.otherLangs) if (d[L.id] && d[L.id] !== f.base) f.dict[L.id] = d[L.id] } }
            if (this.dictState === 'off' || !need.length) { applyCache(); this.dictState = this.dictState === 'off' ? 'off' : 'ok'; return }
            this.dictState = 'loading'
            const langs = this.otherLangs.map(l => l.id)
            try {
                // command (не method): бэк ведёт эти вызовы командами верхнего уровня (views.py request['command']); action.command перекрывает 'executeBackendMethod' в payload
                this.store.executeBackendMethod({}, { command: 'i18n_values_get', params: { texts: need, langs } }, (answer) => {
                    if (!this.visible) return
                    const map = this._dictMap(answer)
                    if (!map) { this.dictState = 'off'; applyCache(); return }
                    for (const s of need) { const d = map[s]; this.dictCache[s] = (d && typeof d === 'object') ? d : {} }
                    this.dictState = 'ok'
                    applyCache()
                })
            } catch (e) { console.warn('i18n_values_get', e); this.dictState = 'off'; applyCache() }
        },
        _dictMap(answer) {
            if (!answer || typeof answer !== 'object') return null
            if (answer.status === 'error') return null
            for (const key of ['values', 'result', 'texts', 'items', 'data']) {
                const v = answer[key]
                if (v && typeof v === 'object' && !Array.isArray(v)) return v
            }
            // сама карта в корне ответа: берём только записи вида text → {uk, ru}
            const out = {}
            let n = 0
            for (const [k, v] of Object.entries(answer)) {
                if (v && typeof v === 'object' && !Array.isArray(v) && Object.keys(v).some(l => LANGUAGE_IDS.includes(l))) { out[k] = v; n++ }
            }
            return n ? out : null
        },
        // ---- IE 2026 09 25 / ODOO-341407 (этап 2 переводов данных 1С): запись загружаемого справочника ----
        // бэк (i18n_values_get с record) говорит, загружаемая ли запись, язык её базы, источник каждого значения названия и что даст загрузка
        recordInfoLoad() {
            const rec = this.record
            const f = this.fields.find(x => x.basePath === 'title')
            if (!f || !rec?.id || !rec.segment || rec._meta?.new || this.dictState === 'off') return
            try {
                this.store.executeBackendMethod({}, { command: 'i18n_values_get', params: { texts: [], langs: this.otherLangs.map(l => l.id), record: { id: rec.id, segment: rec.segment } } }, (answer) => {
                    if (!this.visible || this.record !== rec) return
                    const info = answer?.record
                    if (!info || typeof info !== 'object' || !info.loaded) return
                    this.recInfo = info
                    this.applyRecInfo(f, info)
                })
            } catch (e) { console.warn('i18n_values_get record', e) }
        },
        applyRecInfo(f, info) {
            f.loaded = true
            f.src = { ...(info.src || {}) }
            f.auto = { ...(info.auto || {}) }
            if (info.base_lang && info.base_lang !== 'en' && !f.enVariant) {
                // строка English — английский вариант meta.title_en (ручной / 1С / CLDR), база не правится
                const storedEn = this._str(this.store.get_value(this.record, 'meta.title_en')) || this._str(info.titles?.en)
                const untouched = this._str(f.draft.en) === f.base
                f.enVariant = true
                f.langPaths = { ...f.langPaths, en: 'meta.title_en' }
                f.stored = { ...f.stored, en: storedEn }
                if (untouched) f.draft.en = storedEn
            }
            this.$nextTick(() => this.autosizeAll())
        },
        // языки, которые поле правит переводом (у справочника с не английской базой — и English: вариант meta.title_en)
        editLangs(f) { return f?.enVariant ? this.langs : this.otherLangs },
        placeholderOf(f, lang) {
            if (f.loaded && f.auto?.[lang]?.value) return f.auto[lang].value
            if (lang === 'en') return ''
            return f.dict[lang] || ''
        },
        srcLabel(src) {
            if (src === '1c') return 'BAS'   // IE 2026 09 28 / ODOO-342342: подпись источника — BAS (id источника '1c' прежний)
            if (src === 'cldr') return 'CLDR'
            if (src === 'base') return t('base')
            if (src === 'manual') return t('manual')
            return src || ''
        },
        // ---- правка ячеек ----
        clearCell(f, lang) { f.draft[lang] = '' },
        useDictionary() {
            for (const f of this.fields) for (const L of this.otherLangs) if (!f.draft[L.id] && f.dict[L.id]) f.draft[L.id] = f.dict[L.id]
            this.$nextTick(() => this.autosizeAll())
        },
        resetToDictionary() {
            for (const f of this.fields) for (const L of this.editLangs(f)) f.draft[L.id] = ''   // IE 2026 09 25 / ODOO-341407: и English у справочника с не английской базой
            this.$nextTick(() => this.autosizeAll())
        },
        changes() {
            const items = []
            for (const f of this.fields) {
                const en = this._str(f.draft.en)
                if (f.enVariant) {
                    // IE 2026 09 25 / ODOO-341407: английский вариант (meta.title_en), пустое — снять ручной (вернётся значение из загрузки)
                    const v = en.replace(/\s+$/, '')
                    if (v !== f.stored.en) items.push({ field: f, path: f.langPaths.en, lang: 'en', value: v })
                } else if (en !== f.base) items.push({ field: f, path: f.basePath, lang: 'en', value: en })
                for (const L of this.otherLangs) {
                    const v = this._str(f.draft[L.id]).replace(/\s+$/, '')
                    if (v !== f.stored[L.id] && f.langPaths[L.id]) items.push({ field: f, path: f.langPaths[L.id], lang: L.id, value: v })
                }
            }
            return items
        },
        // ---- Apply ----
        apply() {
            if (this.busy || this.readOnly) return
            const items = this.changes()
            if (!items.length) { this.hide(); return }
            const record = this.record
            if (this.memoryOnly) {
                for (const it of items) this._setPath(record, it.path, it.value, true)
                record._meta = record._meta || {}
                record._meta.modified = true
                this._done(items, { memoryOnly: true })
                this.store.show_notification({ text: t('Translations applied to the form — save the record to store them'), status: 'info' })
                return
            }
            this.busy = true
            this.error = ''
            this.conflict = null
            // IE 2026 09 24 / ODOO-341407: expected — что карточка показала при открытии (база + переводы каждого поля); бэк объявляет конфликт
            // только если целевые поля в базе отличаются от этого (версию записи меняет и сама система — перенумерация order при открытии виджета)
            const expected = {}
            for (const f of this.fields) {
                if (f.basePath) expected[f.basePath] = f.base
                for (const L of this.editLangs(f)) if (f.langPaths[L.id]) expected[f.langPaths[L.id]] = f.stored[L.id]   // IE 2026 09 25 / ODOO-341407: + meta.title_en
            }
            const params = {
                id: record.id, segment: record.segment,
                version: record.version ?? null, sequence_id: record.sequence_id ?? null, updated_at: record.updated_at ?? null,
                items: items.map(it => ({ path: it.path, lang: it.lang, value: it.value })),
                expected,
            }
            try {
                this.store.executeBackendMethod({}, { command: 'i18n_values_set', params }, (answer) => {   // command — см. dictLoad
                    this.busy = false
                    const err = this._answerError(answer)
                    if (err) {
                        const c = answer?.conflict
                        if (c && typeof c === 'object' && c.path) {   // IE 2026 09 24 / ODOO-341407: конфликт по целевому полю — текущее значение + «Reload values»
                            this.conflict = { path: String(c.path), current: this._str(c.current), values: (c.values && typeof c.values === 'object') ? c.values : null }
                            this.error = this._conflictText(this.conflict)
                        } else this.error = err
                        this.store.show_notification({ text: t('Translations are not saved: {error}', { error: this.error }), status: 'error' }); return
                    }
                    // память: те же пути, без пометки modified (запись на бэке уже обновлена)
                    for (const it of items) this._setPath(record, it.path, it.value, false)
                    if (answer?.meta && typeof answer.meta === 'object') {
                        record.meta = record.meta || {}
                        for (const [k, v] of Object.entries(answer.meta)) {
                            if (!/^(title|tooltip|comment)_[a-z]{2}$/.test(k)) continue
                            if (v === undefined || v === null || v === '') delete record.meta[k]; else record.meta[k] = v
                            this.store.i18n_autoUnmark(record, k)   // IE 2026 10 06 / ODOO-341407: значение из базы — не словарное
                        }
                        // IE 2026 09 25 / ODOO-341407: пересчитанные бэком варианты (снятый ручной вернул значение из 1С / CLDR) и их источники
                        if (this.recInfo) {
                            for (const L of this.langs) if (!(('title_' + L.id) in answer.meta)) delete record.meta['title_' + L.id]
                            if (answer.meta.i18n_src && typeof answer.meta.i18n_src === 'object') record.meta.i18n_src = { ...answer.meta.i18n_src }
                            else delete record.meta.i18n_src
                        }
                    }
                    if (answer?.sequence_id) { record.sequence_id = answer.sequence_id; this.store.sync_sequence_id?.(record.id, answer.sequence_id, record) }
                    if (answer?.updated_at) record.updated_at = answer.updated_at
                    this._done(items, { memoryOnly: false, answer })
                    this.store.show_notification({ text: t('Translations saved'), status: 'success' })
                })
            } catch (e) {
                this.busy = false
                this.error = String(e?.message || e)
            }
        },
        // IE 2026 09 24 / ODOO-341407: текст конфликта — поле и язык по пути ответа, текущее значение из базы
        _conflictText(c) {
            let field = null, lang = 'en'
            for (const f of this.fields) {
                if (f.basePath === c.path) { field = f; break }
                const L = this.editLangs(f).find(l => f.langPaths[l.id] === c.path)   // IE 2026 09 25 / ODOO-341407: + English-вариант
                if (L) { field = f; lang = L.id; break }
            }
            const langTitle = (LANGUAGES.find(l => l.id === lang) || {}).title || lang
            return t('{field} ({lang}) was changed by another user: now “{value}”', { field: field ? field.label : c.path, lang: langTitle, value: c.current || '—' })
        },
        // IE 2026 09 24 / ODOO-341407: «Reload values» — текущие значения полей карточки из ответа-конфликта (conflict.values по путям карточки):
        // база / переводы обновляются, нетронутые ячейки берут новое значение, правки пользователя остаются; те же значения — в запись
        // (без пометки modified: это состояние базы), затем Apply повторяется с новым expected
        reloadValues() {
            const c = this.conflict
            if (!c) return
            const vals = c.values || { [c.path]: c.current }
            const take = (path) => (path && Object.prototype.hasOwnProperty.call(vals, path)) ? this._str(vals[path]).replace(/\s+$/, '') : undefined
            for (const f of this.fields) {
                const b = take(f.basePath)
                if (b !== undefined && b !== '') {
                    if (!f.enVariant && this._str(f.draft.en) === f.base) f.draft.en = b   // IE 2026 09 25 / ODOO-341407: строка English варианта — не база
                    if (b !== f.base) { f.base = b; if (this.record) this._setPath(this.record, f.basePath, b, false) }
                }
                for (const L of this.editLangs(f)) {   // IE 2026 09 25 / ODOO-341407: + English-вариант
                    const p = f.langPaths[L.id], v = take(p)
                    if (v === undefined) continue
                    if (this._str(f.draft[L.id]).replace(/\s+$/, '') === f.stored[L.id].replace(/\s+$/, '')) f.draft[L.id] = v
                    if (v !== f.stored[L.id]) { f.stored[L.id] = v; if (this.record) this._setPath(this.record, p, v, false) }
                }
            }
            this.conflict = null
            this.error = ''
            this.dictLoad()
            this.$nextTick(() => this.autosizeAll())
        },
        _answerError(answer) {
            if (!answer || typeof answer !== 'object') return t('no answer from the server')
            if (answer.status === 'error' || answer.ok === false || answer.error || answer.notification?.status === 'error') {
                return this._str(answer.error || answer.text || answer.message || answer.notification?.text || t('error'))
            }
            // проба dev02 24.09: бэк без команды i18n_values_set ответил без status/ok — карточка приняла это за успех и обновила память.
            // Успех — только явное подтверждение по контракту ({ok: true} / status 'ok'); всё иное — ошибка, память не трогаем
            if (answer.ok !== true && answer.status !== 'ok') return this._str(answer.notification?.text || answer.text || t('the server did not confirm the save (is the i18n_values_set command deployed?)'))
            return ''
        },
        _done(items, info) {
            const cb = this.afterApply
            const result = {
                items: items.map(it => ({ path: it.path, lang: it.lang, value: it.value, key: it.field.key })),
                fields: this.fields.map(f => ({ key: f.key, basePath: f.basePath, base: f.enVariant ? f.base : this._str(f.draft.en), stored: Object.fromEntries(this.editLangs(f).map(L => [L.id, this._str(f.draft[L.id]).replace(/\s+$/, '')])), dict: { ...f.dict } })),   // IE 2026 09 25 / ODOO-341407: English-вариант — не база
                record: this.record,
                ...info,
            }
            this.hide()
            try { cb?.(result) } catch (e) { console.warn('i18n card afterApply', e) }
        },
        // запись значения по пути; '' = удалить ключ (перевод снят → словарь / база)
        _setPath(record, path, value, set_modified) {
            const store = this.store
            // IE 2026 10 06 / ODOO-341407 (DESIGN §3.4 п.5): значение, записанное карточкой (Apply в память, после i18n_values_set, «Reload values»), — уже не
            // словарный перевод: снять ключ из meta._i18n_auto, иначе сохранение списка сняло бы его как неправленый словарь (stripAutoForSave)
            store.i18n_autoUnmark(record, path)
            if (value === '' || value === null || value === undefined) {
                const i = path.lastIndexOf('.')
                const parent = i < 0 ? record : store.get_value(record, path.slice(0, i))
                const key = i < 0 ? path : path.slice(i + 1)
                if (parent && typeof parent === 'object' && key in parent) delete parent[key]
                return
            }
            store.set_value(record, path, value, null, null, null, set_modified ? null : false)
        },
        // ---- клавиатура / позиционирование ----
        onKeydown(e) {
            if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); this.hide(); return }
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) { e.preventDefault(); e.stopPropagation(); this.apply(); return }
            if (e.key === 'Enter' && e.target?.tagName === 'INPUT') { e.preventDefault(); this.focusNext(e.target) }
        },
        focusNext(el) {
            const card = this.$refs.card
            if (!card) return
            const all = Array.from(card.querySelectorAll('input.i18n-in, textarea.i18n-in'))
            const i = all.indexOf(el)
            const next = all[i + 1]
            if (next) { next.focus(); try { next.select?.() } catch (e2) { /* textarea */ } }
        },
        focusFirst() {
            const lang = this.curLang === 'en' ? (this.otherLangs[0]?.id || 'en') : this.curLang
            const f0 = this.fields[0]
            const el = f0 && this.$refs['in-' + lang + '-' + f0.key]
            const target = Array.isArray(el) ? el[0] : el
            try { target?.focus() } catch (e) { /* нет элемента */ }
        },
        autosize(el) {
            if (!el || el.tagName !== 'TEXTAREA') return
            el.style.height = 'auto'
            const lh = parseFloat(getComputedStyle(el).lineHeight) || 18
            const max = Math.round(lh * 12 + 10)
            const h = Math.min(el.scrollHeight + 2, max)
            el.style.height = Math.max(h, Math.round(lh + 10)) + 'px'
            el.style.overflowY = el.scrollHeight + 2 > max ? 'auto' : 'hidden'
        },
        autosizeAll() {
            const card = this.$refs.card
            if (!card) return
            for (const ta of card.querySelectorAll('textarea.i18n-in')) this.autosize(ta)
        },
        place() {
            if (this.isMobile) return
            const card = this.$refs.card
            const vw = window.innerWidth, vh = window.innerHeight
            const width = Math.min(Math.max(520, 220 + this.fields.length * 260), vw - 32)
            let left = 16, top = 16
            const r = this.anchorEl?.getBoundingClientRect?.()
            if (r && (r.width || r.height)) {
                left = Math.round(r.left)
                top = Math.round(r.bottom + 6)
            }
            const h = card ? Math.min(card.offsetHeight || 260, vh - 32) : 260
            if (left + width > vw - 16) left = Math.max(16, vw - 16 - width)
            if (top + h > vh - 16) {
                const above = r ? Math.round(r.top - 6 - h) : 16
                top = above >= 16 ? above : Math.max(16, vh - 16 - h)
            }
            this.pos = { left, top, width }
        },
        _installOutside() {
            this._removeOutside()
            this._outside = (e) => {
                const card = this.$refs.card
                if (!this.visible || !card || card.contains(e.target)) return
                if (this.anchorEl && this.anchorEl.contains?.(e.target)) return
                if (this.dirty) return   // ввод не теряем: закрытие — Esc / Cancel / крестик
                this.hide()
            }
            document.addEventListener('mousedown', this._outside, true)
            this._onResize = () => { if (this.visible) this.place() }
            window.addEventListener('resize', this._onResize)
        },
        _removeOutside() {
            if (this._outside) { document.removeEventListener('mousedown', this._outside, true); this._outside = null }
            if (this._onResize) { window.removeEventListener('resize', this._onResize); this._onResize = null }
        },
    },
    beforeUnmount() { this._removeOutside() },
}
</script>

<style>
/* IE 2026 09 24 / ODOO-341407: карточка «Translations» — как окно чипса (.chip-tooltip: белый фон, рамка, тень) */
.i18n-card { position: fixed; z-index: 10010; background: #fff; border: 1px solid var(--surface-border, #dee2e6); border-radius: 8px;
    box-shadow: 0 6px 24px rgba(0, 0, 0, .18); font-size: 13px; color: var(--text-color, #333); display: flex; flex-direction: column;
    max-height: calc(100vh - 32px); box-sizing: border-box; }
.i18n-card-mobile { width: auto; }
.i18n-card-head { display: flex; align-items: center; gap: 8px; padding: 8px 10px; border-bottom: 1px solid var(--surface-border, #dee2e6); }
.i18n-card-globe { color: var(--cs-accent, #647eff); }
.i18n-card-title { font-weight: 600; flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.i18n-card-mode { font-size: 11px; color: var(--text-color-secondary, #6c757d); white-space: nowrap; display: inline-flex; align-items: center; gap: 4px; }
.i18n-card-close { cursor: pointer; color: #d9534f; padding: 2px; }
.i18n-card-close:hover { color: #b52b27; }
.i18n-card-body { overflow: auto; padding: 6px 10px; }
.i18n-table { border-collapse: separate; border-spacing: 0 4px; width: 100%; table-layout: fixed; }
.i18n-th-lang { width: 112px; }
.i18n-th-field { text-align: left; font-weight: 600; font-size: 12px; color: var(--text-color-secondary, #6c757d); padding: 0 6px 2px; }
.i18n-td-lang { vertical-align: top; padding: 6px 6px 0 0; }
.i18n-lang-name { font-weight: 600; white-space: nowrap; }
.i18n-lang-note { font-size: 11px; color: var(--text-color-secondary, #6c757d); white-space: nowrap; }
.i18n-row-base .i18n-lang-name { color: var(--cs-accent, #647eff); }
.i18n-td-cell { vertical-align: top; padding: 0 4px; }
.i18n-cell { display: flex; align-items: flex-start; gap: 4px; }
.i18n-in { flex: 1 1 auto; min-width: 0; width: 100%; box-sizing: border-box; border: 1px solid var(--surface-border, #ced4da); border-radius: 4px;
    padding: 5px 6px; font: inherit; line-height: 1.35; background: #fff; color: inherit; resize: none; }
.i18n-in:focus { outline: none; border-color: var(--cs-accent, #647eff); box-shadow: 0 0 0 2px rgba(100, 126, 255, .18); }
.i18n-in::placeholder { color: #8a8f98; font-style: italic; opacity: 1; }
.i18n-in-multi { max-height: none; overflow-y: hidden; }
.i18n-row-base .i18n-in { background: #fbfbff; }
.i18n-badge { flex: 0 0 auto; display: inline-flex; align-items: center; gap: 4px; min-width: 76px; font-size: 11px; padding-top: 6px; white-space: nowrap; }
.i18n-auto { color: #8a8f98; font-style: italic; }
.i18n-none { color: #b0b4ba; }
.i18n-manual { color: var(--cs-accent, #647eff); }
.i18n-clear { cursor: pointer; color: #9aa0a6; font-size: 11px; }
.i18n-clear:hover { color: #d9534f; }
.i18n-card-legend { font-size: 11px; color: var(--text-color-secondary, #6c757d); padding: 0 10px 6px; }
.i18n-card-base { font-size: 12px; color: var(--text-color-secondary, #6c757d); padding: 2px 0 4px; }   /* IE 2026 09 25 / ODOO-341407: базовое название загружаемой записи */
.i18n-card-foot { display: flex; align-items: center; gap: 6px; padding: 8px 10px; border-top: 1px solid var(--surface-border, #dee2e6); flex-wrap: wrap; }
.i18n-foot-spacer { flex: 1 1 auto; }
.i18n-error { color: #d9534f; font-size: 12px; max-width: 320px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.i18n-btn { border: 1px solid var(--surface-border, #ced4da); background: #fff; color: inherit; border-radius: 4px; padding: 4px 10px; font: inherit; font-size: 12px; cursor: pointer; }
.i18n-btn:hover:not(:disabled) { background: var(--surface-hover, #f2f3f5); }
.i18n-btn:disabled { opacity: .5; cursor: default; }
.i18n-btn-apply { background: var(--cs-accent, #647eff); border-color: var(--cs-accent, #647eff); color: #fff; font-weight: 600; display: inline-flex; align-items: center; gap: 6px; }
.i18n-btn-apply:hover:not(:disabled) { background: #5069f0; }
.i18n-btn-reload { display: inline-flex; align-items: center; gap: 4px; color: #d9534f; border-color: #d9534f; }   /* IE 2026 09 24 / ODOO-341407 */
@media (max-width: 640px) {
    .i18n-table { table-layout: auto; }
    .i18n-th-lang { width: 80px; }
    .i18n-badge { min-width: 0; }
}
</style>
